<template>
  <div class="brand-logo-slider-area">
    <div class="container">
      <div v-if="references">
        <h3 class="h3 hero-content-title font-weight-light">Reference</h3>
      <span v-for="(refik,index) in references.data.references" :key="index">
        <v-btn text x-small outlined class="mr-2">
        <a :href="refik.href" target="_blank" v-html="refik.name"></a>
        </v-btn>
      </span>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'BrandLogoCarousel',
  computed: {
    references() {
      return this.$store.getters['app/content']('a5552c2a-4745-4ed1-9739-c0bca6a5e6aa')
    }
  },
  data() {
    return {
      swiperOption: {
        speed: 300,
        loop: true,
        autoplay: true,
        slidesPerView: 6,
        spaceBetween: 1,
        breakpoints: {
          991: {
            slidesPerView: 4
          },

          767: {
            slidesPerView: 3
          },
          575: {
            slidesPerView: 2
          }
        }
      }
    }
  }
}
</script>